import { css } from '@emotion/core';
export default (classes, variables, customCSS, cybs) => {
  return ({
  tooltip: css`
    max-width: 10rem !important;
    border: 1px solid ${cybs?.base?.wcag21?.stoneGrey ?? '#62798D'} !important;
    &.vds-tooltip {
      z-index: 9999999 !important;
    }
    & .vds-tooltip-text {
      color: ${cybs?.base?.wcag21?.charcoal ?? '#000000'};
    }
  `
})}